export default __webpack_public_path__ + "static/media/4406.a24363b7.png";